import { render, staticRenderFns } from "./AvCheckbox.vue?vue&type=template&id=199e0f16"
import script from "./AvCheckbox.vue?vue&type=script&lang=ts"
export * from "./AvCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./AvCheckbox.vue?vue&type=style&index=0&id=199e0f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports